module.exports = __webpack_public_path__ + "img/中国涂料协会.b9715417.png";